import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell, StyledButtonBlack
} from "../../../styles/MyStyles";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetLookupMenuItems} from "../../../logic/LookupHelper";
import {GetOrderTitle} from "../../../logic/EntityTitleHelper";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";

const TradeEditPage = () => {
    const { clientId, tradeId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [trade, setTrade] = useState({
        contactId: clientId,
        date: '',
        action: 0,
        orderId: '',
        cryptoAmount: '',
        price: '',
        brokerageFee: '',
        transactionFee: '',
        feeAssetId: ''
    });

    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const fetchTrade = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (tradeId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_TRADES_URL}/single/${tradeId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setTrade(data.data);
                    } else {
                        console.log('Fetch trade failed.');
                    }
                } else {
                    setTrade({
                        contactId: clientId,
                        date: '',
                        action: 0,
                        orderId: '',
                        cryptoAmount: '',
                        price: '',
                        brokerageFee: '',
                        transactionFee: '',
                        feeAssetId: ''
                    });
                    console.log(trade);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        const fetchOrders = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_ORDERS_URL}/${clientId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + tokenCookie.value,
                        },
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    console.log(data.data);
                    setOrders(data.data);
                } else {
                    console.log('Fetch orders failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchOrders().then((e) => {
            fetchTrade();
        });
    }, [tradeId]);

    const validateForm = () => {
        let newErrors = {};

        if (trade.date === '') {
            newErrors.date = 'Date is required.';
        }
        if (trade.orderId === '') {
            newErrors.orderId = 'Order is required.';
        }

        if (trade.cryptoAmount === '') {
            newErrors.cryptoAmount = 'Crypto Amount is required.';
        } else if (isNaN(trade.cryptoAmount)) {
            newErrors.cryptoAmount = 'Crypto Amount must be number.';
        }
        if (trade.price === '') {
            newErrors.price = 'Price is required.';
        } else if (isNaN(trade.price)) {
            newErrors.price = 'Price must be number.';
        }

        if (trade.brokerageFee === '') {
            newErrors.brokerageFee = 'Brokerage Fee is required.';
        } else if (isNaN(trade.brokerageFee)) {
            newErrors.brokerageFee = 'Brokerage Fee must be number.';
        }
        if (trade.transactionFee === '') {
            newErrors.transactionFee = 'Transaction Fee is required.';
        } else if (isNaN(trade.transactionFee)) {
            newErrors.transactionFee = 'Transaction Fee must be number.';
        }

        if (trade.feeAssetId === '') {
            newErrors.feeAssetId = 'Fee Asset is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        if (event.target.name === 'orderId') {
            trade.date = '';

            let order = orders.findLast(e => e.id === event.target.value);

            trade.action = order.action;
            trade.sellAssetId = order.sellAssetId;
            trade.buyAssetId = order.buyAssetId;
        }

        setTrade({
            ...trade,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TRADES_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(trade),
                }
            );
            if (response.ok) {
                console.log('Trade updated successfully.');
                handleGoBack();
            } else {
                console.log('Update trade failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const getOrderItems = () => {
        let items = [];
        if (orders) {
            orders.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetOrderTitle(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    }

    const handleDelete = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TRADES_URL}/${tradeId}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Trade deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete trade failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {tradeId ? 'Edit Trade' : 'Create Trade'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(tradeId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Order</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="orderId"
                                label="Order"
                                select
                                value={trade.orderId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.orderId}
                                helperText={errors.orderId}
                            >
                                {getOrderItems()}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="date"
                                label="Date"
                                value={dayjs(trade.date)}
                                minDate={trade.orderId !== '' ? dayjs(orders.findLast(e => e.id === trade.orderId).createdDate) : null}
                                maxDate={trade.orderId !== '' ? dayjs(orders.findLast(e => e.id === trade.orderId).expirationDate) : null}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'date',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.date}
                                helperText={errors.date}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Crypto Amount</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="cryptoAmount"
                                label="Crypto Amount"
                                value={trade.cryptoAmount}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.cryptoAmount}
                                helperText={errors.cryptoAmount}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Price</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="price"
                                label="Price"
                                value={trade.price}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.price}
                                helperText={errors.price}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Fee Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="feeAssetId"
                                label="Fee Asset"
                                select
                                value={trade.feeAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.feeAssetId}
                                helperText={errors.feeAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Brokerage Fee</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="brokerageFee"
                                label="Brokerage Fee"
                                value={trade.brokerageFee}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.brokerageFee}
                                helperText={errors.brokerageFee}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Transaction Fee</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="transactionFee"
                                label="Transaction Fee"
                                value={trade.transactionFee}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.transactionFee}
                                helperText={errors.transactionFee}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default TradeEditPage;
